const counter = document.querySelector(".timer__counter");
if (counter) {


    const dateStartAttr = counter.getAttribute("data-start");

    if (!dateStartAttr) {
        counter.remove();
    }

    const targetDate = new Date(dateStartAttr).getTime();

    const counterDays = document.querySelector(".timer__counter-days");
    const counterHours = document.querySelector(".timer__counter-hours");
    const counterMinutes = document.querySelector(".timer__counter-minutes");
    const counterSeconds = document.querySelector(".timer__counter-seconds");
    console.log('init');

    function updateCounter() {
        console.log('update');

        const now = new Date().getTime();
        const distance = targetDate - now;

        if (distance <= 0) {
            counter.remove();
            clearInterval(interval);
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (counterDays) counterDays.textContent = days;
        if (counterHours) counterHours.textContent = hours;
        if (counterMinutes) counterMinutes.textContent = minutes;
        if (counterSeconds) counterSeconds.textContent = seconds;
    }

    updateCounter();
    const interval = setInterval(updateCounter, 1000);
}